import React, { useEffect, useCallback } from 'react'
import { RootState } from 'store'
import {
  getIsSignin,
  getUserName,
  getEmail,
  getChanneltalkId
} from 'modules/me'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ChannelService from 'ChannelService'

export default function Channeltalk() {
  const isSignin = useSelector((state: RootState) => getIsSignin(state))
  const userName = useSelector((state: RootState) => getUserName(state))
  const email = useSelector((state: RootState) => getEmail(state))
  const channeltalkId = useSelector((state: RootState) =>
    getChanneltalkId(state)
  )
  const history = useHistory()
  const startChannelService = useCallback(() => {
    const pathname = history.location.pathname
    if (pathname == '/' || pathname == '/opensalon') {
      const channelSettings = {
        pluginKey: process.env.REACT_APP_CHANNEL_IO_PLUGIN_KEY!,
        zIndex: 50
      }
      if (isSignin) {
        const crypto = require('crypto')
        const hash = crypto
          .createHmac(
            'sha256',
            Buffer.from(process.env.REACT_APP_CHANNEL_IO_SECRET_KEY!, 'hex')
          )
          .update(channeltalkId)
          .digest('hex')
        Object.assign(channelSettings, {
          memberHash: hash,
          profile: {
            name: userName,
            email: email
          }
        })
      }
      ChannelService.boot(channelSettings)
    } else {
      ChannelService.shutdown()
    }
  }, [history, channeltalkId, email, isSignin, userName])
  useEffect(() => {
    startChannelService()
    history.listen(startChannelService)
  }, [history])

  return <React.Fragment></React.Fragment>
}
